<template lang="pug">
  .fill-width
    .d-flex.mb-2.mt-8.align-center
      h4 Ближайшие трансляции
      v-spacer
      tooltip-wrap(
        text="Создать видеотрансляцию"
        v-if="!study"
      )
        v-btn(
          color="primary" fab outlined small
          :to="{ name: 'ConferenceCreate' }"
        ).mt-n2
          v-icon mdi-plus
    v-row(v-if="loading.conferences")
      v-col(
        v-for="i in 3"
        :key="i"
        cols="12"
      ).translation-block
        v-skeleton-loader(
          type="list-item icon"
        )
    v-row(v-else-if="!conferences.length").ma-0
      v-col.pa-0
        p Трансляции еще не запланированы...

    v-list(
      color="transparent"
      v-else
    )
      v-list-item.py-2.px-2(
        v-for="conference in conferences"
        :key="conference.id"
        target="_blank"
      )
        v-list-item-action.align-self-start.mr-4
          .text-body-2: strong
            .black--text {{ conference.date_start.split(" ")[1] }}
            .grey--text {{ conference.date_end.split(" ")[1] }}
          //- v-icon(color="primary" size="38") $telegram
        v-card.sdo-card.primary.lighten-5.black--text.pa-4.fill-width(
        )
          span: .text-body-2.card-title: strong  {{ conference.title }}

    //- v-card-actions
    //-   v-btn.px-5(
    //-       :to="{ name: 'Schedule' }"
    //-       color="primary"
    //-       rounded
    //-       large
    //-       depressed
    //-     ) Перейти в календарь
</template>

<script>
import {
  format,
} from 'date-fns';

export default {
  name: 'NearestTranslations',
  props: {
    study: { type: Boolean, default: false },
  },
  data: () => ({
    conferences: [],
    loading: {
      conferences: false,
    },
  }),
  created() {
    this.fetchTranslations();
  },
  methods: {
    // async fetchTranslations() {
    //   this.loading.conferences = true;
    //   const query = {
    //     'per-page': 5,
    //     sort: '-date_start',
    //     'search[from_date]': format(new Date(), 'yyyy-MM-dd'),
    //   };
    //   if (this.study) {
    //     query['search[im_learning]'] = true;
    //   } else {
    //     query['search[teacher_id]'] = this.$user.data.teacher_id;
    //   }
    //   const { items } = await this.$api.telegram.conferenceIndex(query);
    //   this.conferences = items;
    //   this.loading.conferences = false;
    // },
    async fetchTranslations() {
      this.loading.conferences = true;
      const query = {
        sort: '-date_start',
        'search[from_date]': format(new Date(), 'yyyy-MM-dd'),
      };
      if (this.study) {
        query['search[me_and_open]'] = 1;
        query['search[im_learning]'] = true;
      } else {
        query['search[teacher_id]'] = this.$user.data.teacher_id;
      }
      const { items } = await this.$api.telegram.conferenceIndex(query);
      // const jazz = await this.$api.schedule.index({ ...query, expand: 'lesson,meeting' });

      this.conferences = items;
      this.loading.conferences = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.widget--translations {

  .translation-block {
    min-width: 170px;
    max-width: 200px;
    max-height: 180px;

    &__content {
      text-decoration: none;
    }

    ::v-deep {
      .v-skeleton-loader {
        height: 100%;
      }
      .v-alert__content {
        width: 100%;
      }
    }
  }
}
</style>
